// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"0b66488d","302":"ba72c1bf","594":"6c40ce04"}[chunkId] + ".chunk.css";
};